import { render, staticRenderFns } from "./ButtonArrow.vue?vue&type=template&id=ac215e5e&scoped=true&"
import script from "./ButtonArrow.vue?vue&type=script&lang=js&"
export * from "./ButtonArrow.vue?vue&type=script&lang=js&"
import style0 from "./ButtonArrow.vue?vue&type=style&index=0&id=ac215e5e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac215e5e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonBlob: require('/opt/build/repo/components/ButtonComponents/ButtonBlob.vue').default})
